import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function SessionRevokedModal() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');

  const handleEvent = useCallback((e) => {
    setMessage(e.detail?.message || t('session_revoked.default_message'));
    setVisible(true);
  }, [t]);

  useEffect(() => {
    window.addEventListener('session-revoked', handleEvent);
    return () => window.removeEventListener('session-revoked', handleEvent);
  }, [handleEvent]);

  const handleDismiss = () => {
    setVisible(false);
    localStorage.removeItem('sessionRevokedByDevice');
    window.location.href = '/login';
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.65)', zIndex: 99999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff', borderRadius: '10px', padding: '28px 32px',
        maxWidth: '420px', width: '90%', textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      }}>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>&#128274;</div>
        <h5 style={{ marginBottom: '10px', fontWeight: 600, color: '#1a1a2e' }}>
          {t('session_revoked.title')}
        </h5>
        <p style={{ color: '#555', fontSize: '14px', marginBottom: '20px', lineHeight: 1.5 }}>
          {message}
        </p>
        <button
          onClick={handleDismiss}
          style={{
            background: '#1a3a5c', color: '#fff', border: 'none',
            borderRadius: '6px', padding: '10px 28px', fontSize: '14px',
            fontWeight: 600, cursor: 'pointer',
          }}
        >
          {t('session_revoked.dismiss')}
        </button>
      </div>
    </div>
  );
}
